import React, { useEffect, useState } from 'react';
import { Card, CardBody } from 'reactstrap';
import { Tooltip } from '@mui/material';
import NoRowOverlay from 'views/pages/manage/academicPlanAndTest/searchAcademicPlan/NoRowOverlay';
import ADataGrid from 'views/pages/manage/common/data-grid/ADataGrid';
import { AGridColDef } from 'views/pages/manage/common/data-grid/ADataGridColDef';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import AInput from 'views/pages/manage/common/formFeilds/customInput/AInput';
import { gridComponents } from 'views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant';
import { gridStyles } from 'views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant';
import { isAlphabet } from 'views/pages/manage/gateAttendance/constant';
import { isNumber } from 'views/pages/manage/gateAttendance/constant';
import { getLabelById } from '../../../paymentMode/constant';
import { CourseDetailsPopupById } from '../../../studentCharges/common';
import { useHistory } from "react-router";
import moment from 'moment';
const ExamReciptListing = ({
    rowData,
    rowCount,
    loader=false,
    searchHandler=()=>{},
    globalFilter,
    dropdownData
}) => {
    const [rows, setRows] = useState()
    const [currentPage, setCurrentPage] = useState()
    const [searchValue, setSearchValue] = useState('')
    const history = useHistory();
    const onChangeHandler = async (page) => {
        setCurrentPage(page)

    }
    useEffect(() => {
        setRows(rowData)
    }, [rowData])
    console.log("rowData",rowData)
        const applySearchHandler=(searchValue)=>{
            // console.log(req,'req')
           const req={
            rollNumber: isNumber(searchValue) ? (searchValue).trim() : "",
            examTimeCode: !isNumber(searchValue) ? (searchValue).trim() : "",
           }
           console.log(req,'req')
           if (req?.rollNumber || req?.examTimeCode){
            console.log(req)
            searchHandler({...globalFilter,...req})
            // setGlobalFilter(filter)
           }
        }

    const columns = [
        new AGridColDef("psid", "PSID", false)
            .setMinWidth(130)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                // params?.value ? <Tooltip title={params?.value}>
                    <div className={`ellipsis-text-container`}>{params?.value}</div>
                // </Tooltip> : <div>-</div>
            )),
        new AGridColDef("rollNumber", "Roll No", false)
            .setMinWidth(130)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                // params?.value ? <Tooltip title={params?.value}>
                    <div className={`ellipsis-text-container`}>{params?.value}</div>
                // </Tooltip> : <div>-</div>
            )),
        new AGridColDef("examTimeCode", "Exam ID", false)
            .setMinWidth(130)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                // params?.value ? <Tooltip title={params?.value}>
                    <div className={`ellipsis-text-container`}>{params?.value}</div>
                // </Tooltip> : <div>-</div>
            )),
        new AGridColDef("courseId", "Course ID", false)
            .setMinWidth(130)
            .editable(true)
            .setFlex(1)
           .renderCellComponent((params) => (
                   <div>
                     <span>{params.value}</span>&nbsp;
                     <span>
                <CourseDetailsPopupById
                courseId={params?.row?.courseId}
                />
                     </span>
                   </div>
                 )),
        new AGridColDef("termId", "Term", false)
            .setMinWidth(130)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                // params?.value ? <Tooltip title={params?.value}>
                    <div className={`ellipsis-text-container`}>{getLabelById(params?.value,dropdownData?.term)}</div>
                // </Tooltip> : <div>-</div>
            )),
        new AGridColDef("businessAreaValue", "Center", false)
            .setMinWidth(130)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                // params?.value ? <Tooltip title={params?.value}>
                    <div className={`ellipsis-text-container`}>{params?.value}</div>
                // </Tooltip> : <div>-</div>
            )),
        new AGridColDef("examDate", "Exam Date", false)
            .setMinWidth(130)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ? <Tooltip title={params?.value}>
                    <div className={`ellipsis-text-container`}>{moment(params?.value).format('DD-MM-YYYY')}</div>
                </Tooltip> : <div>-</div>
            )),
        new AGridColDef("studentClass", "Class", false)
            .setMinWidth(130)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                // params?.value ? <Tooltip title={params?.value}>
                    <div className={`ellipsis-text-container`}>{params?.value}</div>
                // </Tooltip> : <div>-</div>
            )),
        new AGridColDef("action", "Action", false)
            .setMinWidth(130)
            .editable(false)
            .setFlex(1)
            .renderCellComponent((params) => (
                 <AButton
                            onClick={() =>
                              window.open(
                                history.createHref({
                                  pathname: `/admin/examCharges/${params?.row?.psid}`,
                                })
                              )
                            }
                            size="xs"
                            variant="primary_filled"
                            className="btn-left-0"
                            // disabled={!params?.value}
                          >
                            Select
                          </AButton>
            ))

    ]
    return (

        <Card style={{margin:'18px'}}>
        <CardBody>
            <div className='d-flex justify-content-between align-items-center'>
                <div className='dark-text label-color'>Student</div>
                <div className="cursor">
                <AInput
              style={{ height: "31px", width: "335px" }}
              value={searchValue}
              handler={(value) => {
                setSearchValue(value)
              }}
              crossIcon={true}
              rightSearchIcon={true}
              searchIconClickHandler={() => {
                applySearchHandler(searchValue)
                 }}
              crossHandler={async () => { 
                applySearchHandler('') ;
                setSearchValue("")
              
              }}
              placeholder={"Search by exam name or roll no"}
              //maxLength={searchCriteria === "psid" ? 11 : 12}
            />
                </div>
            </div><ADataGrid
            removeWrapperContainer
            // rowModesModel={rowModesModel}
            rows={rows || []}
            columns={columns}
            rowId={(row) => JSON.stringify(row)}
            rowHeight={50}
            loading={false}
            rowCount={rowCount}
            currentPage={currentPage}
            nextButtonHandler={onChangeHandler}
            components={{
                ...gridComponents,
                NoRowsOverlay: () => (
                    <NoRowOverlay message={loader ? "Loading..." : null} />
                ),
            }}
            sx={gridStyles}
            //  pageSize={10}
            autoHeight
            pinLastColumn
        // hidePagination={true}
        /></CardBody></Card>
    )
}
export default ExamReciptListing